module.exports = __webpack_public_path__ + "static/media/InsuredMine.73399e62.svg";